module.exports = __webpack_public_path__ + "static/media/otp-banner.6d049927.jpg";